import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthErrorService } from "../_services/auth-error.service";

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  constructor(
    private authErrorService: AuthErrorService
  ) {}

    intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.shouldHandleAuthError(error, request)) {
          this.authErrorService.handleAuthError(error, request);
        }
        return throwError(error);
      })
    );
  }

  private shouldHandleAuthError(error: HttpErrorResponse, request: HttpRequest<any>): boolean {
    return this.authErrorService.isAuthError(error) && !this.authErrorService.isExcludedUrl(request.url);
  }
} 